<template>
  <canvas v-show="ready" id="dailyProcess" ref="dailyProcess" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStyle } from "@coreui/coreui-pro/dist/js/coreui-utilities";

const brandPrimary = getStyle("--primary");
const brandSecondary = getStyle("--secondary");
const brandSuccess = getStyle("--success");
const brandWarning = getStyle("--warning");
const brandDanger = getStyle("--danger");
const brandInfo = getStyle("--info");

export default {
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  methods: {
    calculate(i) {
      return this.percentage[i];
    }
  },
  data() {
    return {
      ready: false,
      labels: [],
      percentages: [],
      data: [
        {
          type: "line",
          pointStyle: "cross",
          label: "Máximo alcanzado",
          borderDash: [5, 5],
          borderColor: brandSuccess,
          borderWidth: 1.2,
          fill: false,
          data: [],
          datalabels: {
            display: false
          }
        },
        {
          type: "line",
          pointStyle: "cross",
          borderDash: [5, 5],
          label: "Promedio",
          borderColor: brandInfo,
          borderWidth: 1.2,
          fill: false,
          data: [],
          datalabels: {
            display: false
          }
        },
        {
          type: "bar",
          fill: true,
          label: "K Exp",
          backgroundColor: brandPrimary,
          stack: "Stack 0",
          data: [],
          datalabels: {
            rotation: 270,
            display: true,
            color: "white"
          }
        },
        {
          type: "bar",
          fill: true,
          label: "Kg Sub",
          backgroundColor: brandSecondary,
          stack: "Stack 0",
          datalabels: {
            display: false,
            color: "white"
          },
          data: []
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/daily_process?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[3].data = response.data.sum_net_kilograms.map(
        (net, index) => net - response.data.exportable_kilograms[index]
      );
      this.data[2].data = response.data.exportable_kilograms;
      this.data[2].datalabels.formatter = function (value, context) {
        return (
          (
            (response.data.exportable_kilograms[context.dataIndex] /
              response.data.sum_net_kilograms[context.dataIndex]) *
            100
          ).toFixed(1) + " %"
        );
      };
      const maxNet = Math.max.apply(null, response.data.sum_net_kilograms);
      this.data[0].data = response.data.sum_net_kilograms.map((e) => maxNet);
      const avgExp =
        response.data.exportable_kilograms.reduce((a, b) => a + parseFloat(b), 0) /
        response.data.exportable_kilograms.length;
      this.data[1].data = response.data.sum_net_kilograms.map((e) => avgExp);
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    this.ready = true;
    let ctx = this.$refs.dailyProcess.getContext("2d");
    const dailyProcess = new Chart(ctx, {
      type: "bar",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        datalabels: {
          color: "#000"
        },
        plugins: {
          legend: {
            display: false,
            position: "right"
          },
          title: {
            display: true,
            text: "Kg volteados vs exportados por día"
          },
          tooltips: {
            mode: "index",
            intersect: true
          },
          subtitle: {
            display: true,
            text: "Mas porcentaje de embalaje, máximo y promedio del periodo seleccionado"
          }
        },
        scales: {
          x: {
            stacked: true
          }
        },
        animation: {
          onComplete: function (animation) {
            console.log("hola");
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
